import classNames from "classnames";
import {PropsWithChildren, useState} from "react";

import Button from "@/components/button/Button.tsx";
import {ChecksModal, ChecksModalVariantProps} from "@/components/ChecksModalButton/subComponents/ChecksModal.tsx";
import {PropsWithClassName} from "@/lib/types/props.ts";

type ChecksModalButtonProps = ChecksModalVariantProps &
  PropsWithChildren &
  PropsWithClassName & {
    numberOfChecks: number;
    title?: string;
    inline?: boolean;
    onClose?: () => void;
  };

export const ChecksModalButton = ({
  numberOfChecks,
  children,
  className,
  inline,
  onClose,
  ...rest
}: ChecksModalButtonProps) => {
  const [showChecks, setShowChecks] = useState(false);

  const handleClose = () => {
    setShowChecks(false);
    onClose?.();
  };

  return (
    <>
      {numberOfChecks > 0 ? (
        <Button
          variant={"linkBlue"}
          typography={"link"}
          size={inline ? "text" : undefined}
          onClick={() => setShowChecks(true)}
          className={className}
        >
          {children}
        </Button>
      ) : (
        <span className={classNames("px-3", className)}>{children}</span>
      )}
      <ChecksModal show={showChecks} hide={handleClose} {...rest} />
    </>
  );
};
